<template>
    <button
        type="button"
        class="toggle-button"
        :class="{ 'active' : isActive }"
        :disabled="isDisabled"
        @click="$emit('click')"
        :aria-label="label"
    >
        <span class="icon-wrapper">
            <SvgIcon :icon="icon" :is-filled="iconFilled" />
        </span>
        <span class="title">{{ label }}</span>
    </button>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'ToggleButton',
    components: {
        SvgIcon,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        iconFilled: {
            type: Boolean,
            default: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },

}
</script>
<style lang="scss" scoped>
.toggle-button {
    appearance: none;
    -webkit-appearance: none;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: 0;
    font-family: Axiforma, sans-serif;
    cursor: pointer;
    column-gap: .8rem;

    .icon-wrapper {
        background-color: #657787;
        border-radius: 50%;
        height: 2.6rem;
        width: 2.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;

        svg {
            height: 1.5rem;
            width: 1.5rem;
            margin-right: 0;
        }
    }

    .title {
        font-size: 1.4rem;
        line-height: 1.7rem;
        text-align: left;
        font-weight: 500;
        color: #657787;
    }

    &.active {
        .icon-wrapper {
            background-color: #25C8C1;
        }

        .title {
            color: #25C8C1;
        }
    }

    &:disabled {
        .icon-wrapper {
            background-color: #F1F1F1;
        }

        .title {
            color: #F1F1F1;
        }
    }
}
</style>
